import { Loader2 } from 'lucide-react';
import * as React from 'react';
import { cn } from '@/lib/utils';

const Spinner = React.forwardRef<SVGSVGElement, React.ComponentProps<'svg'>>(
  ({ className, ...props }, ref) => (
    <Loader2
      ref={ref}
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      className={cn(
        'size-4 animate-spin motion-reduce:animate-none',
        className,
      )}
      {...props}
    />
  ),
);

Spinner.displayName = 'Spinner';

export { Spinner };
